import { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import InputWrapper from "../InputWrapper/InputWrapper";
import styles from "./RadioButtons.module.scss";

export default function RadioButtons({
  id,
  name,
  label,
  options,
  inputType = "radio",
  direction = "vertical",
  currentValue = null,
  register,
  formState,
  attributes,
  wrapperProps,
  customLabels,
  controlled = true,
}) {
  const [selected, setSelected] = useState(null);
  const optionProps = controlled ? { ...register(id) } : "";

  const { trigger } = useFormContext();

  useEffect(() => {
    if (inputType === "checkbox" || Array.isArray(currentValue)) {
      if (!currentValue) {
        setSelected([]);
        return;
      }

      const currentValueArray = Array.isArray(currentValue)
        ? currentValue
        : [currentValue];

      setSelected(currentValueArray?.map((value) => `${id}-${value}`));

      return;
    }

    if (id && currentValue) {
      setSelected(`${id}-${currentValue}`);
      return;
    }

    setSelected(null);
  }, [currentValue, id, inputType, options]);

  const handleInput = (value) => {
    trigger(id);
  };

  const optionInputs = options.map((option, index) => {
    /* Would be nice to support passing custom ids, but value/id have to be predictably
     ** related to enable default selection on page load.
     */
    const optionId = `${id}-${option.value.replace(" ", "")}`;

    const isSelected =
      inputType === "radio"
        ? selected === optionId
        : selected?.includes(optionId);

    return (
      <div
        key={`${optionId}-${index}`}
        className={`${styles.inputContainer} ${isSelected ? "checked" : ""}`}
      >
        <input
          type={inputType}
          id={optionId}
          value={option.value}
          className={`${customLabels ? styles.customLabel : ""}`}
          onInput={handleInput}
          {...attributes}
          {...optionProps}
        />
        <label htmlFor={optionId} className={`${styles.radioButtonLabel}`}>
          {option.label}
        </label>
      </div>
    );
  });

  const itemsPerRow = optionInputs.length % 4 === 1 ? 3 : 4;

  return (
    <InputWrapper label={label} id={id} formState={formState} {...wrapperProps}>
      <div
        className={`${styles.radioButtons} ${styles[direction]} ${
          customLabels ? styles.customLabels : ""
        } ${itemsPerRow === 3 ? styles.threeItemRow : ""}`}
      >
        {optionInputs}
      </div>
    </InputWrapper>
  );
}
